import { render, staticRenderFns } from "./EditEventDocument.vue?vue&type=template&id=0cc8ada7&scoped=true&"
import script from "./EditEventDocument.vue?vue&type=script&lang=js&"
export * from "./EditEventDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc8ada7",
  null
  
)

export default component.exports